module.exports = __webpack_public_path__ + "static/media/about4.9a5e4d1d.webp";